(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-tennis/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-tennis/assets/javascripts/init-box.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_tennis = svs.themes.sport_tennis || {};
  svs.themes.sport_tennis.initStatus = function(data) {
    setTimeout(function() {
      var $init = $('[data-init-id="' + data.matchId + '"] .js-live-clock');

      if ($init.length) {
        _.each($init, function(init) {
          $(init).replaceWith(svs.themes.sport_tennis.initStatusStart(data));
        });
      }
    }, 60000);

    var $init = $('[data-init-id="' + data.matchId + '"] .js-live-clock');
    if ($init.length) {
      _.each($init, function(init) {
        $(init).replaceWith(
          svs.themes.sport_tennis.initStatusStart(data, true)
        );
      });
    }
  };

  svs.themes.sport_tennis.hasMatchMinutes = function() {
    return true;
  };

  svs.themes.sport_tennis.initStatusStart = function(data, noclock) {
    var diff = 0;

    if (svs.themes.sport_tennis.isLive(data.status.id)) {
      if (data.status.id === 8) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 1</div>';
      }

      if (data.status.id === 9) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 2</div>';
      }

      if (data.status.id === 10) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 3</div>';
      }

      if (data.status.id === 11) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 4</div>';
      }

      if (data.status.id === 12) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 5</div>';
      }
      if (data.status.id === 13) {
        return '<div class="brick match-status brick-active f-condensed align-center">SET 1</div>';
      }

      if (data.status.id === 14) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }
      if (data.status.id === 26) {
        return '<div class="brick match-status brick-active f-condensed align-center">AVBR</div>';
      }

      if (data.status.id === 27) {
        return '<div class="brick match-status brick-active f-condensed align-center">UPPH</div>';
      }

      if (data.status.realTime) {
        diff = Math.ceil(
          Math.abs(
            svs.themes.getDifferenceBetweenDates(
              data.status.realTime,
              new Date().setSeconds(0, 0),
              'minutes',
              false
            )
          )
        );
      }

      if (diff >= 0) {
        data.status.minutes = diff;
      } else {
        data.status.minutes = 1;
      }

      if (!noclock) {
        svs.themes.sport_tennis.initStatus(data);
      }

      return (
        '<div data-init-time-status="' +
        data.timeId +
        '" class="brick js-live-clock match-status brick-active f-condensed align-center">' +
        data.status.minutes +
        "'</div>"
      );
    } else if (svs.themes.sport_tennis.isEnded(data.status.id)) {
      if (data.status.id === 25) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">INST</div>';
      }
      if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      }

      if (
        data.status.id === 29 ||
        data.status.id === 116 ||
        data.status.id === 117 ||
        data.status.id === 120 ||
        data.status.id === 121
      ) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      }
      if (
        data.status.id === 26 ||
        data.status.id === 30 ||
        data.status.id === 118 ||
        data.status.id === 119
      ) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">AVBR</div>';
      }

      if (data.status.id === 31 || data.status.id === 41) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      }
    } else if (data.startTime) {
      return (
        '<div class="brick match-status brick-border f-condensed align-center">' +
        svs.themes.formatTime(data.startTime) +
        '</div>'
      );
    }

    return '';
  };
})(svs);

 })(window);